<template>
  <v-dialog v-model="dialog" max-width="650" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark :color="color">
          <v-toolbar-title>Konfirmasi Data Pembagian Sebaran Satuan Pendidikan KS</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <v-alert
          v-if="error"
          dense
          icon="mdi-information"
          close-text="Tutup"
          border="left"
          type="error"
          colored-border
          class="bg-error ma-0 mb-3"
        >
          <div class="black--text">{{ error }}</div>
        </v-alert>
        <div class="title black--text mb-3" v-html="title"></div>
        <div class="subtitle-2 black--text mb-2" v-html="desc"> </div>
        <v-checkbox class="mt-2 mb-3" v-model="isChecked" hide-details>
          <template v-slot:label>
            <div class="body-2 black--text">
              {{ quote }}
            </div>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn text color="grey" right @click="close" elevation="0">
            BATAL
          </v-btn>
          <v-btn dark class="mr-2" :color="color" left @click="onSave" :disabled="!isChecked">
            {{ okLabel }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      isChecked: false,
      error: null,
      color: 'orange',
      jenis: 'konfirm',
      okLabel: 'Ya, Data Sesuai',
      title: `Apakah Anda yakin bahwa pengisian Sebaran Satuan Pendidikan Kepala Sekolah yang diterima untuk semua jenjang dan daerah sudah
          benar ?`,
      desc: `
          Proses ini akan mengkonfirmasi bahwa Sebaran Satuan Pendidikan Kepala Sekolah yang telah Anda isikan sudah benar dan akan
          dikirimkan ke semua PMO Dinas Daaerah terkait
          <span class="error--text body-2">
            (pembatalan Sebaran Satuan Pendidikan hanya bissa dilakukan dengan reset tahapan <b>3.Konfirmasi Pusat</b> pada tiap-tiap
            daerah)
          </span>
      `,
      quote: 'Sebaran Satuan Pendidikan Kepala Sekolah yang saya isikan sudah benar',
    };
  },
  methods: {
    open() {
      this.$set(this, 'error', null);
      this.$set(this, 'isChecked', false);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    onSave() {
      this.$emit('save');
    },
  },
};
</script>
